import { getContainer } from '@framework/di/getContainer';
import { useCallback, useEffect, useState } from 'react';
import useRouter from '@framework/hooks/useNextRouter';
import IDeal from '@/creditflowresearch/domain/vo/IDeal';
import { ICorporateDeal } from '@/creditflowresearch/domain/vo/Deals/CorporateDeal';
import DealRepository from '@/creditflowresearch/infrastructure/repository/DealRepository';
import { parseDealViewId } from '@/creditflowresearch/application/Deal/helpers/parseDealViewId';
import { AlertManager } from '@creditflowresearch/uilib/Alert';
import { getErrorMessage } from '@framework/message/Mapper/getMessage';

const useDealPage = (dealItem: IDeal) => {
  const container = getContainer();
  const { query: { dealId } } = useRouter();
  const [isFirstFetching, setIsFirstFetching] = useState<boolean>(true);
  const [deal, setDeal] = useState<IDeal | ICorporateDeal>(dealItem);
  const [isFetching, setIsFetching] = useState(false);

  const dealRepository = container.get<DealRepository>(DealRepository);

  const fetchDeal = useCallback(
    async (viewId: number) => {
      try {
        setIsFetching(true);
        const response = await dealRepository.getDealCardByViewId(viewId);
        setDeal(response);
      } catch (error) {
        AlertManager.error(getErrorMessage(error));
      } finally {
        setIsFetching(false);
      }
    },
    [],
  );

  useEffect(() => {
    if (isFirstFetching) {
      return;
    }

    const viewId = parseDealViewId(dealId);
    if (viewId === null) {
      return;
    }

    fetchDeal(viewId);
  }, [dealId]);

  useEffect(() => {
    setIsFirstFetching(true);
    setDeal(dealItem);
  }, [dealItem]);

  return {
    isFetching,
    deal,
    fetchDeal,
  };
};

export default useDealPage;
